var map = {
	"./music-instructions.json": 4284,
	"./music-library-intro2024.json": 4285,
	"./music-library-launch2024.json": 4286,
	"./music-progression.json": 4287,
	"./startSourcesAdvanced.json": 4288,
	"./startSourcesSimple.json": 4289,
	"./startSourcesSimple2.json": 4290,
	"./startSourcesTracks.json": 4291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4027;